import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

import {Installation} from '../types/installation';

@Component({
  selector: 'one-install',
  template: `<div *ngIf="!header; else headerRow" [style.background-color]="this.statusColor(row)">
    <span class="job_id">{{row.job_id}}</span>
    <span class="status">{{row.status}}</span>
    <span class="name">{{row.first_name}} {{row.last_name}}</span>
    <span class="uploaded">{{row.uploaded | godate}}</span>
</div>
<ng-template #headerRow>
    <span class="job_id center" (click)="sortBy('job_id',true)">ID</span>
    <span class="status" (click)="sortBy('status',false)">Status</span>
    <span class="name" (click)="sortBy('name',false)">Name</span>
    <span class="uploaded" (click)="sortBy('uploaded',false)">uploaded</span>
</ng-template>
`,
  styles: [
    `span { display: inline-block; margin: 0.1em 0.2em; padding: 0.1em 0.3em; border: 2px solid transparent;
              border-radius: 6px; line-height: 200%; }`,
    `span.job_id { color: white; padding-left: 0.6em; padding-right: 0.6em; background-color: #607D8B; width: 2.5em;
              border-radius: 0; border: none; }`,
    `.status { width: 10em; }`,
    `.name { width: 19em; }`,
    `.uploaded { width: 11em; text-align: center; }`,
  ]
})


export class OneInstallationRowComponent {
  @Input() row: Installation;
  @Input() header = false;
  @Output() sortColumn = new EventEmitter<string>();
  errorMessage: any;

  constructor(
  ) { }

  sortBy(column: string, numeric: boolean) {
    this.sortColumn.emit(column + ':' + numeric);
  }

  statusColor(thisRow: Installation): string {
    let status = this.row.status;
    if (status !== 'JOB_COMPLETED') {
      status = this.row.geopal_data['status'];
    }
    if (status === 'JOB_ACCEPTED') { return '#E0FFF0'; }
    if (status === 'JOB_ASSIGNED') { return '#D8FFE8'; }
    if (status === 'JOB_INPROGRESS') { return '#C8FFD8'; }
    if (status === 'JOB_COMPLETED') { return '#C0FFD0'; }
    if (status === 'JOB_CANCELLED') { return '#D07070'; }
    if (status === 'JOB_DELETED') { return '#D07070'; }
    if (status === 'JOB_REJECTED') { return '#D07070'; }
    if (status === 'JOB_UNASSIGNED') { return '#F0DFD0'; }
    if (status === 'JOB_STATUS_MISSING') { return '#E08080'; }
    if (status === 'JOB_INCOMPLETE') { return '#E08080'; }
    console.log('Status colour for row: ' + status + ' i.e. ' + thisRow.status
      + ' job_id: ' + thisRow.job_id + ' name: ' + thisRow.first_name);
    // console.log('This row: ' + JSON.stringify(this.row));
    return 'transparent';
  }

}

